import { inject, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

import { MessageService } from '../message.service';
import { AppDefinition } from '../app-definition';
import { AppResource } from '../app-resource';
import { AppService } from '../app.service';
import { RepoService } from '../repo.service';

@Component({
    selector: 'app-app-detail',
    templateUrl: './app-detail.component.html',
    styleUrls: ['./app-detail.component.scss'],
    standalone: true,
    imports: [RouterModule]
})
export class AppDetailComponent implements OnInit {

  appDefId: string;
  app: AppDefinition;
  resources: AppResource[];

  private route: ActivatedRoute = inject(ActivatedRoute);
  private appService: AppService = inject(AppService);
  private messageService: MessageService = inject(MessageService);
  private repoService: RepoService = inject(RepoService);
  private router: Router = inject(Router);

  ngOnInit(): void {
    this.messageService.set(`Viewing app...`);
    this.appDefId = this.route.snapshot.paramMap.get('id');
    this.messageService.set(`Viewing app ${this.appDefId}...`);
    this.appService.getAppDefinition(this.appDefId)
        .subscribe(appDef => this.app = appDef);
  }

  /** Delete app and child deployments */
  onDelete(app: AppDefinition): void {
    this.messageService.set(`Deleting app...`);

    console.warn('  deleting app id: '+ app.id + '; process deployments: '
        + (app.processDeployments == undefined ? ' none ' : app.processDeployments.length));
    if (app.processDeployments == undefined || app.processDeployments.length == 0) {
      this.onDeleteApp(app);
    } else {
      app.processDeployments.forEach(dep => {
        console.warn('  deleting process deployment id: '+ dep.id);
        this.repoService.deleteProcessDeployment(dep.id, true /*cascade*/)
            .subscribe(() => {
          this.onDeleteApp(app);
        });
      });
    }
  }

  onDeleteApp(app: AppDefinition): void {
    console.warn('  deleting app deployment id: ' + app.deploymentId);
    this.appService
        .deleteAppDeployment(app.deploymentId)
        .subscribe(() => {
      this.router.navigate(['/apps']);
    });
  }

}
